if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        if (window.reasnAnalytics) {
          const fd = new FormData(this.form);
          window.reasnAnalytics.track('pdp_atc_clicked', {
            variant_id: String(fd.get('id') || ''),
            quantity: Number(fd.get('quantity') || 1),
            source: this.submitButton && this.submitButton.closest('sticky-add-to-cart') ? 'sticky' : 'main'
          });
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const removeLoadingState = () => {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading__spinner").classList.add("hidden");
        };

        try {
          const config = typeof fetchConfig === 'function' ? fetchConfig("javascript") : {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }
          };
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id),
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          const cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

          fetch(cartAddUrl, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButtonText.classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
                return;
              }

              const startMarker =
                typeof window.CartPerformance !== "undefined"
                  ? window.CartPerformance.createStartingMarker("add:wait-for-subscribers")
                  : null;
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                }).then(() => {
                  if (startMarker && typeof window.CartPerformance !== "undefined") {
                    window.CartPerformance.measureFromMarker(
                      "add:wait-for-subscribers",
                      startMarker,
                    );
                  }
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      if (typeof window.CartPerformance !== "undefined") {
                        window.CartPerformance.measure("add:paint-updated-sections", () => {
                          this.cart.renderContents(response);
                        });
                      } else {
                        this.cart.renderContents(response);
                      }
                    });
                  },
                  { once: true },
                );
                quickAddModal.hide(true);
              } else {
                if (typeof window.CartPerformance !== "undefined") {
                  window.CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                } else {
                  this.cart.renderContents(response);
                }
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              removeLoadingState();
              if (typeof window.CartPerformance !== "undefined") {
                window.CartPerformance.measureFromEvent("add:user-action", evt);
              }
            });
        } catch (error) {
          console.error('Error in onSubmitHandler:', error);
          removeLoadingState();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const buttonsContainer = this.querySelector(".product-form__buttons");
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
          if (
            buttonsContainer &&
            (text === window.variantStrings.soldOut ||
              text === window.variantStrings.unavailable)
          ) {
            buttonsContainer.classList.add("hidden");
          }
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          if (buttonsContainer) buttonsContainer.classList.remove("hidden");
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
